import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";

import "./loadingSvg2.scss";

const LoadingSvg2 = ({ loadingText = "" }) => {
    const location = useLocation();
    return (
        <div className="loading-overlay loading-center">
            <div className="svg-background">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
            </div>
            {!location.pathname.includes("open-enrollment") && <div className="loading-text">{loadingText}</div>}
        </div>
    );
};

LoadingSvg2.propTypes = {
    loadingText: PropTypes.string
};

LoadingSvg2.defaultProps = {
    loadingText: ""
};
export default LoadingSvg2;
